import { createPermission } from '@backstage/plugin-permission-common';

export const amqpTopologyCreateDraftPermission = createPermission({
  name: 'amqp-topology-manager.draft.create',
  attributes: { action: 'create' },
});

export const amqpTopologyReadDraftPermission = createPermission({
  name: 'amqp-topology-manager.draft.read',
  attributes: { action: 'read' },
});

export const amqpTopologyDeleteDraftPermission = createPermission({
  name: 'amqp-topology-manager.draft.delete',
  attributes: { action: 'delete' },
});

export const amqpTopologyCompleteDraftPermission = createPermission({
  name: 'amqp-topology-manager.draft.complete',
  attributes: { action: 'create' },
});

export const amqpTopologySubmitDraftPermission = createPermission({
  name: 'amqp-topology-manager.draft.submit',
  attributes: { action: 'create' },
});

export const amqpTopologyPermissions = [
  amqpTopologyCreateDraftPermission,
  amqpTopologyReadDraftPermission,
  amqpTopologyCompleteDraftPermission,
  amqpTopologySubmitDraftPermission,
];
